import gql from "graphql-tag"

const getRecommendations = (bookingNumber) => (gql`{ 
    ancillaryRecommendations (bookingNumber: "${bookingNumber}") {
        type
        title
        short_title
        description
        img
        url
        isControlGroup
    }
}`)

const getMyHolidayToken = (bookingNumber) => (gql`{
    myHolidayToken (bookingNumber: "${bookingNumber}") {
        token
    }
}`)

const getRecommendedExcursions = (bookingNumber) => (gql`{
    recommendedExcursions (bookingNumber: "${bookingNumber}") {
        eligibleToBook
        availableExcursions
        widgetLink
        recommendations {
            name
            image
            description
            url
            id
            city {
                country {
                    id
                    iso_code
                    name
                }
                cover_image_url
                id
                name
                time_zone
                url
            }
            coordinates {
                latitude
                longitude
            }
            price {
                adult {
                    currency
                    value
                    formatted_iso_value
                }
                child {
                    currency
                    value
                    formatted_iso_value
                }
            }
        }
    }
}`)

export {
    getRecommendations,
    getMyHolidayToken,
    getRecommendedExcursions
}